import { provideChameleonDesignSystem } from '@getgo/chameleon-toolkit';
import { chameleonNav } from './Nav.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonNav());
}
